import fetchAPI from "./fetchAPI"

export async function eventSignUp({
  firstName,
  lastName,
  phone,
  email,
  activityId,
  pin,
  comment,
  captcha,
  token
}) {
  const { eventSignUp } = await fetchAPI(
    `mutation($firstName: String!, $lastName: String!, $phone: String!, $email: String!, $comment: String, $activityId: Int!, $pin: String!, $captcha: String!, $token: String) {
      eventSignUp(firstName: $firstName, lastName: $lastName, phone: $phone, email: $email, comment: $comment, activityId: $activityId, pin: $pin, captcha: $captcha, token: $token) {
        success
        message
      }
    }`,
    {
      variables: {
        firstName,
        lastName,
        phone,
        email,
        pin,
        comment,
        activityId: +activityId,
        captcha,
        token
      }
    }
  )

  return eventSignUp
}

export async function fetchEventBooking(token, captcha) {
  const { fetchEventBooking } = await fetchAPI(
    `query($token: String!, $captcha: String!) {
      fetchEventBooking(token: $token, captcha: $captcha) {
        error,
        booking,
        event
      }
    }`,
    {
      variables: { token, captcha }
    }
  )

  return fetchEventBooking
}

export async function cancelEventBooking(token, captcha) {
  const { cancelEventBooking } = await fetchAPI(
    `mutation($token: String!, $captcha: String!) {
      cancelEventBooking(token: $token, captcha: $captcha) {
        error,
        message
      }
    }`,
    {
      variables: { token, captcha }
    }
  )

  return cancelEventBooking
}

export async function fetchEventPreview(id, captcha) {
  const { fetchEventPreview } = await fetchAPI(
    `query($id: ID!, $captcha: String!) {
      fetchEventPreview(id: $id, captcha: $captcha) {
        error,
        event
      }
    }`,
    {
      variables: { id, captcha }
    }
  )

  return fetchEventPreview
}

export async function fetchEventSeats(id, captcha) {
  const { fetchEventSeats } = await fetchAPI(
    `query($id: ID!, $captcha: String!) {
      fetchEventSeats(id: $id, captcha: $captcha) {
        error,
        seats
      }
    }`,
    {
      variables: { id, captcha }
    }
  )

  return fetchEventSeats
}
